module.exports = __webpack_public_path__ + "static/media/model-gogoro-viva.bf2ef116.png";